/* eslint-disable new-cap */

import './style.scss'
import 'material-symbols'

import HTML from '@datkat21/html'
import { SpotifyApi } from '@spotify/web-api-ts-sdk'
import { registerSW } from 'virtual:pwa-register'
import eruda from 'eruda'

eruda.init()

declare global {
  interface Window {
    isSafari: boolean
  }
}

function checkIsSafari (): boolean {
  return !!(navigator.userAgent.includes('Safari') &&
  !navigator.userAgent.includes('Chrome') &&
  !navigator.userAgent.includes('Firefox'))
}

window.isSafari = checkIsSafari()

const updateSW = registerSW()
updateSW(true).catch(e => {
  console.error('Failed to update service worker:', e)
})

window.onload = async () => { await updateSW() }

let spDc = window.localStorage.getItem('sp_dc')
while (spDc == null) {
  spDc = prompt('Please enter your Spotify cookie (sp_dc):')
}

const res = await fetch(`https://cors.thinliquid.workers.dev?url=${encodeURIComponent('https://open.spotify.com/get_access_token?reason=transport&productType=web_player')}`, {
  method: 'GET',
  headers: {
    'x-cors-headers': JSON.stringify({
      Cookie: `sp_dc=${spDc}`,
      'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.3'
    })
  }
})
if (!res.ok) {
  spDc = null
  while (spDc == null) {
    spDc = prompt('Please enter your Spotify cookie (sp_dc):')
  }
}
const json = await res.json()
console.log(json)

window.localStorage.setItem('sp_dc', spDc)

const auth = (): SpotifyApi => SpotifyApi.withAccessToken(json.clientId, {
  token_type: 'Bearer',
  expires_in: json.accessTokenExpirationTimestampMs - Date.now(),
  refresh_token: json.refreshToken,
  access_token: json.accessToken
})

// Start Spotify SDK Authorization flow
let sdk: SpotifyApi | null = navigator.onLine
  ? auth()
  : null

window.onload = async () => {
  if (sdk == null) return
  await sdk.currentUser.profile()
}

(async () => {
  const Queue = await import('./queue')
  const queue = new Queue.default()

  const Player = await import('./player')
  const player = new Player.default(sdk, queue)

  const Visualizer = await import('./visualizer')
  // eslint-disable-next-line no-new
  new Visualizer.default(player)

  const Lyrics = await import('./lyrics')
  // eslint-disable-next-line no-new
  new Lyrics.default(player, queue)

  const QueuePalette = await import('./queuepal')
  const queuePalette = new QueuePalette.default(player, queue)

  const SearchPalette = await import('./searchpal')
  const palette = new SearchPalette.default(sdk, player, queue)

  const Color = await import('./color')
  const color = new Color.default()

  const Metadata = await import('./metadata')
  // eslint-disable-next-line no-new
  new Metadata.default(sdk, player, color, palette, queuePalette, queue)

  if (!window.isSafari) {
    return
  }
  const div = new HTML('div')
    .styleJs({
      display: 'flex',
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'black',
      color: 'white',
      zIndex: '99999'
    })
    .append(
      new HTML('h1')
        .styleJs({
          fontWeight: '300'
        })
        .text('click to enter')
    )
    .appendTo(document.body)
  const _ = (): void => {
    div.cleanup()

    player.audio.src = 'https://raw.githubusercontent.com/rafaelreis-hotmart/Audio-Sample-files/master/sample.mp3'
    player.audio.play().catch(console.error)
    player.audio.pause()

    div.un('click', _)
  }

  div.on('click', _)
})().catch(console.error)

window.ononline = async () => {
  if (sdk != null) return
  sdk = navigator.onLine
    ? auth()
    : null
}

window.onoffline = () => {
  sdk = null
}
